import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const videos = [
  ['https://youtu.be/atCC8QdiTaw', '活動花絮'],
  ['https://youtu.be/EoeIf0m9FCM', '協辦機構的話：數碼港'],
  ['https://youtu.be/0RW5CSNXqVI', '策略夥伴的話：畢馬威中國'],
  ['https://youtu.be/nBl6u1KnWH4', '策略夥伴的話：智慧城市聯盟'],
  ['https://youtu.be/pTDkHORF2Ic', '評審主席的話：鄧淑明博士，MH，JP'],
  ['https://youtu.be/-UxHpCqxCoc', '得獎者訪問：阿爾卑斯醫療科技有限公司'],
  ['https://youtu.be/hkJ5vuM5XWc', '得獎者訪問：甄港科技'],
] as const;

const ytImg = (url: string) => `https://img.youtube.com/vi/${url.split('/').pop()}/maxresdefault.jpg`;

const HighlightsVideo2022Zh = () => {
  use2022Page({ cate: 'highlightsVideo', lang: 'zh', title: '2022智慧生活夥伴大獎 - 花絮影片' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="Highlights"><div className="Highlights_info"><div className="Highlights_Title">花絮</div><div className="Highlights_TitleLine"><div className="Highlights_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="Highlights_Table_Video"><div className="Highlights_Video_Photos"><a href="/2022/zh/highlights.php"><p>相片</p></a></div><div className="Highlights_Video_Videos"><a href="/2022/zh/highlightsVideo.php"><p>影片</p></a></div><div className="Highlights_Video_Articles"><a href="https://www.etnet.com.hk/www/tc/news/topic_news_category.php?category=smartlivingawards" target="_blank" rel="noreferrer"><p>文章</p></a></div></div><div className="Highlights_Video_Table">{videos.map(([url,title]) => <div className="Highlights_Video_VideoBox" key={url}><div className="Highlights_Video_VideoBox_Video"><a href={url} target="_blank" rel="noreferrer"><img src={ytImg(url)} alt="" /></a><p>{title}</p></div></div>)}<div className="Highlights_Video_VideoBox_blank"></div></div></div></section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default HighlightsVideo2022Zh;

